export default "__VITE_ASSET__D4T9jyjl__"